import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isDestructive?: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  isDestructive = false,
  isLoading = false,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container-confirm animate-pop-in" role="dialog" aria-modal="true" aria-label={title}>
        <div className="modal-header-confirm">
          <div className={`modal-icon-bg ${isDestructive ? 'bg-red' : 'bg-green'}`}>
            <AlertTriangle size={24} color={isDestructive ? '#ef4444' : '#22c55e'} />
          </div>
          <button className="modal-close-btn" onClick={onCancel} disabled={isLoading} aria-label="Fermer">
            <X size={20} />
          </button>
        </div>
        
        <div className="modal-body-confirm">
          <h3>{title}</h3>
          <p>{message}</p>
        </div>

        <div className="modal-footer-confirm">
          <button className="btn-modal-secondary" onClick={onCancel} disabled={isLoading}>
            {cancelLabel}
          </button>
          <button 
            className={`btn-modal-primary ${isDestructive ? 'destructive' : ''}`}
            onClick={onConfirm}
            disabled={isLoading}
            style={{ opacity: isLoading ? 0.7 : 1, cursor: isLoading ? 'wait' : 'pointer' }}
          >
            {isLoading ? 'En cours...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
